export enum ImportType {
  ImportErrorCodes = 'ImportErrorCodes',
  ImportTrDocumentation = 'ImportTrDocumentation',
  ImportAlarmMask = 'ImportAlarmMask',
  ImportAlarmMaskTranslation = 'ImportAlarmMaskTranslation',
}
